module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/logo24MX.afe4b49e.svg";